import React,{useState,useEffect} from 'react';
import IconEdit from "./Edit";
import IconSave from "./Save";
import IconUndo from "./Undo";
import IconLight from "./Light";
import IconDark from "./Dark";
import YuqueSug from "./YuqueSug";
import YuqueSugDark from "./YuqueSugDark";
import Close from "./Close";
import YuqueLoading from "./YuqueLoading";
import ArrowDown from './ArrowDown';
import ListEmpty from './ListEmpty';
import StepInto from './StepInto'
import StepOut from './StepOut'
import StepOver from './StepOver'
import New from "./New";
import Star from "./Star";
import NewCorner from "./NewCorner";
import Wink from "./Wink"
import Scissors from "./Scissors"
import CustomerService from "./CustomerService";
import ChatBubble from "./ChatBubble";
import EditSheet from "./EditSheet";
import FullSize from "./FullSize";

const wrapIcon = (IconComponent) => {
  return (props) => {
    // 处理父组件传来的属性
    const {color, size, blink, style, className} = props;
    const thisColor = color?color:"currentColor"
    const thisSize = size?size:"16px"
    const [bgColor, setBgColor] = useState(thisColor); // 初始颜色

    //闪烁效果
    useEffect(() => {
      if (blink) {
        const interval = setInterval(() => {
          setBgColor(prevColor => (prevColor === 'yellow' ? thisColor : 'yellow'));
        }, 500); // 每500毫秒切换颜色

        // 持续两次闪烁后停止
        const timer = setTimeout(() => {
          clearInterval(interval);
          setBgColor(thisColor); // 确保最后为白色
        }, 2000); // 2秒后停止闪烁

        return () => {
          clearInterval(interval); // 清理定时器
          clearTimeout(timer); // 清理超时
        };
      }
    }, []);
    return (
      <IconComponent color={bgColor} size={thisSize} style={style} className={className}/>
    );

  };
};

const Icons = {
  Edit : wrapIcon(IconEdit),
  Save : wrapIcon(IconSave),
  Undo : wrapIcon(IconUndo),
  Light : wrapIcon(IconLight),
  Dark : wrapIcon(IconDark),
  YuqueSug : wrapIcon(YuqueSug),
  YuqueSugDark : wrapIcon(YuqueSugDark),
  Close : wrapIcon(Close),
  YuqueLoading : wrapIcon(YuqueLoading),
  ArrowDown : wrapIcon(ArrowDown),
  ListEmpty: wrapIcon(ListEmpty),
  StepInto: wrapIcon(StepInto),
  StepOut: wrapIcon(StepOut),
  StepOver: wrapIcon(StepOver),
  New: wrapIcon(New),
  Star: wrapIcon(Star),
  NewCorner: wrapIcon(NewCorner),
  Wink: wrapIcon(Wink),
  Scissors: wrapIcon(Scissors),
  CustomerService: wrapIcon(CustomerService),
  ChatBubble: wrapIcon(ChatBubble),
  EditSheet: wrapIcon(EditSheet),
  FullSize: wrapIcon(FullSize),
};
export default Icons;
